import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
    deleteTagGroup,
    editGroup,
    getClientTagGroups,
    insertGroup,
    setSelectedGroup,
    setSelectedGroupBySlug,
    getSelectedGroup,
    getCurrentTagGroups,
} from './segments.state';
import { SelectedGroup } from './segments.types';

export interface WithTagGroupsProps {
    selectedGroup: SelectedGroup;
    setSelectedGroupBySlug: Function
}

export const withSegments = connect(
    state => ({
        tagGroups: getCurrentTagGroups(state),
        selectedGroup: getSelectedGroup(state),
    }),
    dispatch => bindActionCreators({
        getClientTagGroups,
        setSelectedGroup,
        setSelectedGroupBySlug,
        insertGroup,
        editGroup,
        deleteTagGroup,
    }, dispatch),
);
